import styled from 'styled-components';

import {
    PRIMARY_BASE,
    SURFACE_BASE,
    TERTIARY_BACKGROUND,
} from '@amzn/ring-common-style-library/lib/colors';

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;

    position: relative;
`;

const ChatHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    padding: 16px;
    gap: 10px;

    background-color: ${SURFACE_BASE};
    border-bottom: 1px solid ${TERTIARY_BACKGROUND};
`;

const ChatStatusIndicator = styled.div`
    display: flex;
    align-items: center;
    margin-right: auto;
    gap: 4px;
`;

const CloseButton = styled.div`
    display: flex;
    flex: 0 0 auto;
    width: 24px;
    height: 24px;

    cursor: pointer;
`;

const HeaderIcon = styled.div`
    width: 30px;
    height: 18px;
`;

const HeaderIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;

    /* background is the new "Ring Blue" regardless of dark/light theme */
    background-color: #007ACC;
    border-radius: 4px;
`;

const MenuButton = styled.div`
    display: flex;
    width: 24px;
    height: 24px;

    gap: 8px;
    cursor: pointer;
`;

const MenuContainer = styled.div`
    position: absolute;
    right: 16px;
    top: 60px;
    z-index: 5; // overlay body & new message indicator content
`;

export default {
    ChatHeader,
    ChatStatusIndicator,
    CloseButton,
    HeaderIcon,
    HeaderIconWrapper,
    HeaderWrapper,
    MenuButton,
    MenuContainer,
}